import { LegacyDataTableBody, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import type { PhaseResource } from "@octopusdeploy/octopus-server-client";
import type * as React from "react";
import FrozenPhaseStatusIcon from "~/components/PhaseStatusIcon/FrozenPhaseStatusIcon";
import PhaseStatusIcon from "~/components/PhaseStatusIcon/PhaseStatusIcon";
import type { LifecycleStatus } from "~/utils/MapProgressionToStatus/MapProgressionToStatus";
import styles from "./style.module.less";
interface PhaseHeaderProps {
    className?: string;
    phase: PhaseResource;
    lifecycleStatus: LifecycleStatus;
    isOptional: boolean;
    title: React.ReactNode;
    actionButton: React.ReactNode;
    environmentId?: string;
    isFrozen: boolean;
}
const PhaseHeader: React.FC<PhaseHeaderProps> = (props) => {
    return (<LegacyDataTableBody>
            <LegacyDataTableRow className={props.className}>
                <LegacyDataTableRowColumn>
                    {props.isFrozen ? <FrozenPhaseStatusIcon /> : <PhaseStatusIcon phase={props.phase} status={props.lifecycleStatus} environmentId={props.environmentId}/>}
                    {props.title}
                </LegacyDataTableRowColumn>
                <LegacyDataTableRowColumn />
                <LegacyDataTableRowColumn />
                <LegacyDataTableRowColumn className={styles.deploymentRowButton}>
                    {props.actionButton}
                    <div className={styles.deploymentExpander}/>
                </LegacyDataTableRowColumn>
            </LegacyDataTableRow>
        </LegacyDataTableBody>);
};
PhaseHeader.displayName = "PhaseHeader"
PhaseHeader.displayName = "PhaseHeader";
export default PhaseHeader;
